"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GlobalStylesScope = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var defaultTheme = _interopRequireWildcard(require("./theme"));

var GlobalStylesScope = _styledComponents["default"].div.withConfig({
  displayName: "ThemeProvider__GlobalStylesScope",
  componentId: "qtiyh6-0"
})(["", " *,*:before,*:after{box-sizing:border-box;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.font;
});

exports.GlobalStylesScope = GlobalStylesScope;

var ThemeAndScopedStylesProvider = function ThemeAndScopedStylesProvider(_ref2) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["theme", "children"]);
  return _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (0, _objectSpread2["default"])({}, defaultTheme, theme, {
      color: (0, _objectSpread2["default"])({}, defaultTheme.color, theme.color)
    })
  }, _react["default"].createElement(GlobalStylesScope, props, children));
};

ThemeAndScopedStylesProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  theme: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    font: _propTypes["default"].string
  })])
};
ThemeAndScopedStylesProvider.defaultProps = {
  theme: defaultTheme
};
var _default = ThemeAndScopedStylesProvider;
exports["default"] = _default;